export { onChangeUserCMP, isAllowed, init, createStorageClient } from './cmp';
